import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { ArrowRight } from './../icon/icon-map';

@Component({
  selector: 'phx-banner',
  templateUrl: './phx-banner.component.html',
  styleUrls: ['./phx-banner.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'phx-banner',
    '[class.phx-banner-fixed]': 'phxIsFixed',
    '[class.phx-banner-profile]': 'phxIsProfile',
    '[class.phx-banner-info]': '!phxIsProfile',
  },
})
export class PhxBannerComponent {
  @Input() phxIsProfile: boolean = true;
  @Input() phxTitle: string;
  @Input() phxIsFixed: boolean = false;
  @Input() phxShowNextIcon: boolean = true;
  @Output() phxNextClick: EventEmitter<void> = new EventEmitter<void>();

  public ArrowRightIcon = ArrowRight;

  public onNextClick(): void {
    this.phxNextClick.emit();
  }
}
